var map = {
	"./1.webp": 6689,
	"./10.webp": 5611,
	"./2.webp": 2964,
	"./3.webp": 1766,
	"./4.webp": 5363,
	"./5.webp": 5462,
	"./6.webp": 3644,
	"./7.webp": 3831,
	"./8.webp": 6061,
	"./9.webp": 455
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1471;